import React, { useState } from 'react';
import { Store } from '../../store';
import { Button, Flex, Input, Text } from '@chakra-ui/react';
import { useDimensions } from '../../utils/dimensions';
import posthog from 'posthog-js';

const MAX_LENGTH = 180;
const LENGTH_BOUNDARY = MAX_LENGTH * (2 / 3);

export const NameCollection: React.FC<{
  submitName: (name: string) => void;
  skipName: () => void;
}> = (props) => {
  const { submitName, skipName } = props;
  const [name, setName] = useState('');
  const labels = Store.useState((s) => s.labels);
  const { isDesktop } = useDimensions();
  const trySubmitName = () => {
    if (!name.trim().length) {
      skipName();
      posthog.capture('SKIP-NAME');
    } else {
      submitName(name);
      posthog.capture('SUBMIT-NAME');
    }
  };
  return (
    <>
      <Flex align="flex-start" justify="space-between" mb="12px">
        <Text variant="paragraph-medium" id="remark-email-collection">
          {labels.whatsYourName}
        </Text>
        <Text variant="paragraph-small" color="scheme.contentTertiary" ml="8px" minW="34px">
          1 {labels.of} 2
        </Text>
      </Flex>

      <Input
        variant="in-chat-input"
        autoFocus={isDesktop}
        aria-labelledby="remark-name-collection"
        inputMode="text"
        enterKeyHint="send"
        maxLength={MAX_LENGTH}
        placeholder={labels.firstNamePlaceholder}
        onChange={(e) => {
          setName(e.target.value);
        }}
        value={name}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            trySubmitName();
          }
        }}
      />
      <Text
        variant="paragraph-small"
        marginBottom="0"
        color="scheme.contentTertiary"
        textAlign="end"
        lineHeight="12px"
        fontSize="10px"
        as="label"
        display="block"
        float="right"
        hidden={name.length <= LENGTH_BOUNDARY}
      >
        {name.length} / {MAX_LENGTH}
      </Text>

      <Button
        variant="submit-cta"
        marginTop={name.length <= LENGTH_BOUNDARY ? '12px' : '0px'}
        onClick={() => trySubmitName()}
      >
        {labels.firstNameSubmit}
      </Button>
      <Text
        _hover={{ textDecoration: 'underline' }}
        cursor="pointer"
        variant="label-small"
        color="scheme.contentTertiary"
        onClick={() => {
          skipName();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            skipName();
          }
        }}
        textAlign="center"
        mt="12px"
        tabIndex={0}
      >
        {labels.firstNameSkip}
      </Text>
    </>
  );
};
